import {API_ORGANIZATION_TREE, API_ORGANIZATION_LIST, API_ORGANIZATION_DELETE, API_ORGANIZATION_SAVE, API_EMPLOYEE_ONTIN_DEPARTMENT_LIST} from '@/common/constants';
import { get, post, del, put } from '@/utils/http';

export const getOrganizationTree = () => {
    return get(API_ORGANIZATION_TREE, {});
};

export const getEmployeeListByDepartmentId = (currentPage = 1, pageSize = 10, departmentId, keyWord, positionIds) => {
    return get(API_ORGANIZATION_LIST, {currentPage, pageSize, departmentId: departmentId, trueName: keyWord, positionIds: positionIds});
};

export const delEmployeeDepartment = (id) => {
    return del(API_ORGANIZATION_DELETE.replace(':id', id));
};

export const saveMultEmployeeDepartment = (employeeDepartment) => {
    return post(API_ORGANIZATION_SAVE, employeeDepartment);
};

export const getEmployeeListNotInDept = (currentPage = 1, pageSize = 10, departmentId, keyWord) => {
    return get(API_EMPLOYEE_ONTIN_DEPARTMENT_LIST, {currentPage, pageSize, departmentId: departmentId, trueName: keyWord});
};



// WEBPACK FOOTER //
// ./src/data-model/system/organization-model.js